// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import { InputGroup } from "react-bootstrap";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";

import CardStatContent from "../../components/CardStatContent";

const NurseryContent = forwardRef(
    (
        {
            branchList,
            libCategories,
            statPeriod,
            selectedCategorySubOption = "-",
            updateViewSubOption,
            onViewSubOptionSelected,
            selectedCategorySubOption2 = "content",
            updateViewSubOption2,
            onViewSubOption2Selected,
            onSelectNursery,
            statAll,
            updateCategoryStat,
        },
        ref
    ) => {
        const [subOptionApplied, setSubOptionApplied] = useState(false);
        const [loadingData, setLoadingData] = useState(false);
        const [branchId, setBranchId] = useState(selectedCategorySubOption);
        const [totalChild, setTotalChild] = useState(false);
        const [stat, setStat] = useState(false);
        const [tableData, setTableData] = useState(false);
        const [searchParam, setSearchParam] = useState({
            type: "",
            value: "",
        });

        const typeTitle = selectedCategorySubOption2 === "content" ? "순" : "누적";
        let listColumn = [
            {
                headerName: "No",
                headerClass: "bg-dark text-light",
                field: "id",
                width: 80,
                minWidth: 50,
                resizable: true,
                cellClass: "text-center",
                filter: false,
                valueGetter: "node.rowIndex + 1",
                pinned: 'left'
            },
            {
                headerName: "지사명",
                headerClass: "bg-dark text-light",
                field: "branchName",
                minWidth: 150,
                resizable: true,
                cellClass: "text-left",
                filter: false,
                pinned: 'left'
            },
            {
                headerName: "원명",
                headerClass: "bg-dark text-light",
                field: "name",
                minWidth: 150,
                resizable: true,
                cellClass: "text-left",
                filter: false,
                pinned: 'left'
            },
            {
                headerComponentParams: {
                    template:
                        '<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">가입<br/>원아 수</div></div>',
                },
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                field: "childJoin",
                minWidth: 100,
                resizable: true,
                filter: false,
                cellRenderer: (param) => {
                    return param.value ? param.value.toLocaleString() : "-";
                },
            },
            {
                headerComponentParams: {
                    template:
                        `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">전체 콘텐츠<br/>${typeTitle} 실행 수</div></div>`,
                },
                headerClass: "bg-dark text-light",
                cellClass: "text-center",
                field: "playCountTotal",
                minWidth: 100,
                resizable: true,
                filter: false,
                cellRenderer: (param) => {
                    return param.value ? param.value.toLocaleString() : "-";
                },
            },
        ];

        if (libCategories) {
            listColumn = listColumn.concat(
                libCategories.map((lc) => {
                    return {
                        headerComponentParams: {
                            template: `<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">${lc.name}<br/>${typeTitle} 실행 수</div></div>`,
                        },
                        headerClass: "bg-dark text-light",
                        cellClass: "text-center",
                        field: `playCountCat_${lc.id}`,
                        minWidth: 100,
                        resizable: true,
                        filter: false,
                        cellRenderer: (param) => {
                            return param.value ? param.value.toLocaleString() : "-";
                        },
                    };
                })
            );
        }

        useImperativeHandle(ref, () => ({
            getExcelData(callback) {
                const excelData = {
                    fileName: "플라잉홈_원별통계",
                    sheets: [
                        {
                            name: "원",
                            title: `원별 콘텐츠 사용 ${typeTitle} 통계`,
                            columnTitle: [
                                "지사명",
                                "원명",
                                "가입 원아 수",
                                `전체 콘텐츠 ${typeTitle} 실행 수`,
                            ].concat(libCategories ? libCategories.map((lc) => `${lc.name} ${typeTitle} 실행 수`) : []),
                            data: stat ? stat.map((s) => [s.branchName, s.name, s.childJoin, s.playCountTotal].concat(libCategories ? libCategories.map((lc) => s[`playCountCat_${lc.id}`]) : 0)) : [],
                        },
                    ],
                };
                callback(null, excelData);
            },
        }));

        const getStat = () => {
            if (!selectedCategorySubOption) {
                return;
            }
            setLoadingData(true);
            setBranchId(selectedCategorySubOption);
            setTotalChild(null);
            setStat(null);
            setTableData(null);
            axios({
                method: "POST",
                url: `/api/flyeng_stat_2022/home/branch/${selectedCategorySubOption}/nursery/content`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                    type: selectedCategorySubOption2,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        updateCategoryStat(result.data.data);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                    setLoadingData(false);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    setLoadingData(false);
                });
        };

        const applyData = (data) => {
            const totalChild = {statDate: data.lastChildStatDate, nurseryCount: 0, classCount: 0, contractChild: 0, childJoin: 0};
            const nurseries = data.nurseries;
            const statCategoryBase = {};
            libCategories.forEach((lc) => (statCategoryBase[`cat_${lc.id}`] = 0));
            if (nurseries && nurseries.length > 0) {
                nurseries.forEach((s) => {
                    const branch = branchList.find((b) => b.id === s.branchId);
                    if (branch) {
                        s.branchName = branch.name;
                    }
                    totalChild.nurseryCount += 1;
                    totalChild.classCount += s.classCount || 0;
                    totalChild.contractChild += s.contractChild || 0;
                    totalChild.childJoin += s.childJoin || 0;
                });
                nurseries.sort((a, b) => b.playCountTotal - a.playCountTotal);
            }

            setTotalChild(totalChild);
            setStat(nurseries);
            applyTableData(searchParam, nurseries);
        };

        useEffect(() => {
            if (!subOptionApplied && updateViewSubOption && updateViewSubOption2) {
                updateViewSubOption([{ name: "전체", id: "-" }].concat(branchList), selectedCategorySubOption || "-");
                updateViewSubOption2(
                    [
                        { name: "콘텐츠 순 실행 수", id: "content" },
                        { name: "콘텐츠 누적 실행 수", id: "sum" },
                    ],
                    selectedCategorySubOption2 || "content"
                );
                setSubOptionApplied(true);
            }
            return () => {};
        }, []);

        useEffect(() => {
            if (subOptionApplied) {
                getStat();
            }
            return () => {};
        }, [subOptionApplied]);

        useEffect(() => {
            getStat();
        }, [statPeriod, selectedCategorySubOption, selectedCategorySubOption2]);

        useEffect(() => {
            if(statAll) {
                applyData(statAll);
            }
        }, [statAll]);

        const handleKeyPress = (e) => {
            if (e.key === "Enter") {
                onSearch();
            }
        };
        const onSearch = () => {
            applyTableData(searchParam, stat);
        };

        const applyTableData = (searchParam, list) => {
            var tableData = listSearch(searchParam, list);

            setTableData(tableData);
            setSearchParam(searchParam);
        };

        const searchField = ["branchName", "name"];
        const listSearch = (searchParam, list) => {
            var tableDataNew = [];
            if (!searchParam.value) {
                tableDataNew = list;
            } else {
                list.forEach((item) => {
                    searchField.forEach((field) => {
                        if (item[field] && item[field].indexOf(searchParam.value) >= 0) {
                            if (tableDataNew.findIndex((d) => d.nurseryId == item.nurseryId) == -1) {
                                tableDataNew.push(item);
                            }
                        }
                    });
                });
            }
            return tableDataNew;
        };

        const onRowSelected = (e) => {
            if (onSelectNursery && e && e.data) {
                onSelectNursery(e.data.id, e.data.name, e.data.branchId, e.data.branchName);
            }
        };

        return (
            <div className="stat-branch-content">
                <div className="row w-100 mb-0 mt-0 text-right">
                    <div className="col">
                        <div className="text-right text-muted text-xs">* 원아 자료 기준일 - {totalChild ? totalChild.statDate : ""}</div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                        <CardStatContent id="1" title="계약 원" total={totalChild ? (totalChild.nurseryCount || 0).toLocaleString() : "-"} titleBgClass="bg-tomonote" />
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                        <CardStatContent id="2" title="계약 클래스" total={totalChild ? (totalChild.classCount || 0).toLocaleString() : "-"} titleBgClass="bg-tomonote" />
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                        <CardStatContent id="3" title="계약 원아 수" total={totalChild ? (totalChild.contractChild || 0).toLocaleString() : "-"} titleBgClass="bg-tomonote" />
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                        <CardStatContent id="3" title="가입 원아 수" total={totalChild ? (totalChild.childJoin || 0).toLocaleString() : "-"} titleBgClass="bg-tomonote" />
                    </div>
                </div>
                <div className="row mb-1">
                    <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                        <h5 className="mb-0" style={{ alignSelf: "end" }}>
                            <span>
                                {tableData ? tableData.length.toLocaleString() : "0"} / {stat ? stat.length.toLocaleString() : "0"}
                            </span>
                        </h5>
                    </div>
                    <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12">
                        <InputGroup className="input-group my-group">
                            <input
                                className="form-control"
                                type="text"
                                value={searchParam.value}
                                placeholder="지사명|원명"
                                onChange={(e) => {
                                    const param = { ...searchParam };
                                    param.value = e.target.value;
                                    setSearchParam(param);
                                }}
                                onKeyPress={handleKeyPress}
                            />
                            <InputGroup.Append>
                                <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                            </InputGroup.Append>
                        </InputGroup>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <AgGridReactEx
                            columnDefs={listColumn}
                            headerHeight={40}
                            rowData={tableData}
                            onRowClicked={(e) => {
                                onRowSelected(e);
                            }}
                            pagination={true}
                            overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                        />
                    </div>
                </div>
            </div>
        );
    }
);

export default NurseryContent;
